import React, {Component} from "react";
import {connect} from 'react-redux';
import {slide as Menu} from 'react-burger-menu'
import {NavLink} from "react-router-dom";
import {closeAdminBurgerMenu, openAdminBurgerMenu,} from "../../actions/general";

class AdminBurgerMenu extends Component {
    showSettings(event) {
        event.preventDefault();
    }

    handleStateChange = (state) => {
        state.isOpen?
            this.props.openAdminBurgerMenu()
            :
            this.props.closeAdminBurgerMenu()
    };

    render() {
        let icon = '';
        if(this.props.notificationsIconCount!==undefined && this.props.notificationsIconCount>0)
            icon = <span className="notifications-icon">{this.props.notificationsIconCount}</span>;
        var styles = {
            bmBurgerButton: {
                position: 'absolute',
                width: '36px',
                height: '30px',
                left: '36px',
                top: '36px'
            },
            bmBurgerBars: {
                background: '#373a47'
            },
            bmCrossButton: {
                height: '24px',
                width: '24px'
            },
            bmCross: {
                background: '#bdc3c7'
            },
            bmMenuWrap: {
                zIndex: 3
            },
            bmMenu: {
                background: 'white',
                padding: '2.5em 1.5em 0',
                fontSize: '1.15em',
                color:'black'
            },
            bmMorphShape: {
                fill: '#373a47'
            },
            bmItemList: {
                color: '#b8b7ad',
                padding: '0.8em'
            },
            bmOverlay: {
                background: 'rgba(0, 0, 0, 0.3)'
            }
        };

        return (
            <Menu styles={ styles } isOpen={this.props.menuOpen} onStateChange={(state) => this.handleStateChange(state)} >
                <NavLink onClick={() => this.props.closeAdminBurgerMenu()} className="menu-item" id="newUser"  to={"/newUser"} >Create user</NavLink>
                <NavLink onClick={() => this.props.closeAdminBurgerMenu()} className="menu-item" id="users" to={"/users"} >View users</NavLink>
                <NavLink onClick={(e)=>{e.preventDefault();this.props.logout();this.props.closeAdminBurgerMenu()}} className="menu-item" id="logoff" to={"#"} >Log off</NavLink>

            </Menu>
        );
    }
};

const mapStateToProps = (state) => {
    return {
        menuOpen: state.general.adminBurgerMenuOpen
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        openAdminBurgerMenu: (payload) => {
            dispatch(openAdminBurgerMenu(payload))
        },
        closeAdminBurgerMenu: (payload) => {
            dispatch(closeAdminBurgerMenu(payload))
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminBurgerMenu);

